import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Tipo} from '../models/Tipo';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  url: string = environment.CommonDataUrl;

  constructor(private readonly httpClient: HttpClient) { }

  public getLetraList(): Observable<string[]> {
    return this.httpClient.get<string[]>(this.url + "/letra-codes")
  }
}
